module.exports = __webpack_public_path__ + "static/media/09.172dc0b7.gif";